import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDetailsContainer from '../../../baseContainers/BaseDetailsContainer';
import InputTextComponent from '../../../components/inputs/InputTextComponent';
import AppPrefixUtils from '../../../utils/AppPrefixUtils';
import YesNoDialog from '../../../components/YesNoDialog';
import VoucherCategoryService from '../../../services/VoucherCategoryService';
import FileUploadService from '../../../services/FileUploadService';
import SettingService from '../../../services/SettingService';
import VoucherCategoryDetailsResponse from './VoucherCategoryDetailsResponse';
import VoucherCategoryCreateRequest from './VoucherCategoryCreateRequest';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import InputLanguageDropdownComponent from '../../../components/inputs/InputLanguageDropdownComponent';

class VoucherCategoryContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new VoucherCategoryService());
        this.state = {
            loading: true,
            elementId: props.elementId,
            locale: props.locale,
            showConfirmRemoveDialog: false,
            supportedLocales: [],
            element: {
                translations: [],
            },
        };
        this.settingService = new SettingService();
        this.fileUploadService = new FileUploadService();
        this.editorRef = React.createRef();
        this.renderLocalLanguages = this.renderLocalLanguages.bind(this);
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    updateElement(data) {
        this.setState(
            {
                element: VoucherCategoryDetailsResponse.copy(this.state.element, data),
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }

    setElement() {
        const {viewMode} = this.props;
        const {elementId, locale} = this.state;
        this.beforeUpdateElement(viewMode, elementId, locale);
    }

    beforeUpdateElement(viewMode, elementId, locale) {
        if (elementId && (viewMode === 'EDIT' || viewMode === 'VIEW')) {
            this.blockUi();
            this.service
                .get(elementId, locale)
                .then((data) => {
                    this.setState({loading: false, locale}, () => this.updateElement(data));
                })
                .catch((err) => {
                    this.handleGetDetailsError(err);
                });
        } else {
            this.setState({loading: false}, this.initAfterSetElement());
        }
    }

    handleRemove() {
        this.setState({
            showConfirmRemoveDialog: true,
        });
    }

    remove(type, costam, target) {
        if (target.value) {
            this.scrollToTop();
            this.service
                .removeVoucherCategory(this.state.elementId)
                .then(() => {
                    const {backUrl} = this.props;
                    this.blockUi();
                    this.persistMessage('success', '', t('voucherCategory.successRemove'));
                    // window.location.href = backUrl;
                    this.props.history.push(backUrl);
                })
                .catch(() => {
                    this.setState({showConfirmRemoveDialog: false});
                    this.showErrorMessage(t('voucherCategory.removeError'));
                    this.unblockUi();
                });
        } else {
            this.setState({showConfirmRemoveDialog: false});
        }
    }

    initBeforeSetElement() {
        this.settingService
            .getSupportedLocales()
            .then((supportedLocales) => {
                this.setState({
                    supportedLocales,
                    element:
                        this.props.viewMode === 'NEW'
                            ? new VoucherCategoryCreateRequest(this.props.locale, supportedLocales)
                            : new VoucherCategoryDetailsResponse(supportedLocales),
                });
            })
            .catch(() => {
                this.showErrorMessage(t('error.getSupportedLocalesError'));
            });
    }

    prepareHeaderItems() {
        const {backUrl} = this.props;
        return [
            {
                customRenderFunction: this.renderLocalLanguages,
                rendered: true,
                className: 'float-left',
            },
            {
                label: t('global.back'),
                // href: AppPrefixUtils.locationHrefUrl(backUrl),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
                },
                className: 'gray float-right',
                rendered: true,
            },
        ];
    }
    prepareFooterItems() {
        const {detailUrl, editUrl, locale} = this.props;
        const viewMode = this.viewMode() ? this.viewMode() : this.props.viewMode;
        const editHref = `${editUrl}/${this.state.element?.id}/${locale}`;
        const detailHref = `${detailUrl}/${this.state.element?.id}/${locale}`;
        return [
            {
                label: t('global.save'),
                className: 'float-left',
                onClick: this.handleFormSubmit,
                rendered: viewMode === 'NEW' || viewMode === 'EDIT',
            },
            {
                label: t('global.cancel'),
                // href: AppPrefixUtils.locationHrefUrl(detailHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(detailHref));
                },
                className: 'gray',
                rendered: viewMode === 'EDIT',
            },
            {
                label: t('global.edit'),
                // href: AppPrefixUtils.locationHrefUrl(editHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(editHref));
                },
                iconName: 'mdi-pencil',
                className: 'float-right',
                rendered: this.props.viewMode === 'VIEW',
            },
            {
                label: t('global.remove'),
                onClick: this.handleRemove.bind(this),
                className: 'float-right',
                iconName: 'mdi-delete',
                rendered: this.props.viewMode === 'VIEW' || this.props.viewMode === 'EDIT',
            },
        ];
    }
    getContainerListName() {
        return 'voucher-category-list-container';
    }

    getAddSucces() {
        return t('voucherCategory.createdMessage');
    }

    getUpdateSucces() {
        return t('voucherCategory.updatedMessage');
    }
    getRemoveSucces() {
        return t('voucherCategory.removedMessage');
    }

    prepareElementBeforeRequest(element) {
        element.translations = Object.assign({}, element.translations);
        return element;
    }

    renderLocalLanguages() {
        const {viewMode} = this.props;
        return (
            <InputLanguageDropdownComponent
            id='locale'
            name='locale'
            label={t('global.languageChooser')}
            validator={this.validator}
            validators='not_required'
            value={this.state.locale}
            options={this.state.supportedLocales}
            insideTable
            viewMode={'EDIT'}
            onChange={this.handleChange}
            rendered
            showClear={false}
            stateField={``}
        />
        );
    }

    getBackLabel() {
        return t('global.backToList');
    }

    render() {
        return (
            <div className='container-fluid'>
                {this.renderView()}
                <YesNoDialog
                    onChange={this.remove.bind(this)}
                    visible={this.state.showConfirmRemoveDialog}
                    header={t('voucherCategory.removeTitle')}
                    name='visible'
                    onHide={() => {
                        this.setState({showConfirmRemoveDialog: false});
                    }}
                >
                    {' '}
                </YesNoDialog>
            </div>
        );
    }

    breadCrumbItems() {
        return [
            {name: t('voucherCategory.listName'), url: '/voucher-category-list'},
            {name: t('voucherCategory.details'), url: ``},
        ];
    }

    renderDetails() {
        return (
            <React.Fragment>
                <div className='col-md-12 col-sm-12'>
                    <InputTextComponent
                        id={`name`}
                        name='name'
                        label={t('voucherCategory.name')}
                        colClass='col-sm-12 col-md-8 col-lg-6 col-xl-4'
                        validator={this.validator}
                        value={this.state?.element?.translations[this.state?.locale]?.name}
                        validators='required|alpha_space_dash|max:255'
                        onChange={this.handleChange}
                        stateField={`element.translations[${this.state?.locale}]`}
                        viewMode={this.props.viewMode}
                    />
                </div>
            </React.Fragment>
        );
    }
}

VoucherCategoryContainer.defaultProps = {
    backUrl: '/voucher-category-list',
    editUrl: '/voucher-category/edit',
    detailUrl: '/voucher-category/details',
    lazy: true,
};

VoucherCategoryContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    editUrl: PropTypes.string,
    detailUrl: PropTypes.string,
};

export default withRouter(withTranslation()(VoucherCategoryContainer));
